import React from "react";
import { Route, Navigate } from "react-router-dom";
import Protected from "../components/Protected";
import UserNotifications from "../pages/User-pages/UserNotifications";
const UserRoutes = () => {
  const routes = [
    <Route
      key="view-notifications-route-1"
      path="/user/communications/notifications/:id?"
      element={
        <Protected>
          <UserNotifications />
        </Protected>
      }
    />,

    <Route
      path="/user/communications"
      element={<Navigate to={"/user/communications/notifications/"} />}
    />,
  ];
  return routes;
};
export default UserRoutes;
